import { brand as fallbackBrand } from "./config";

/**
 * Merge API storefront config over compile-time FE-05a brand tokens.
 * API never executes code — only JSON fields (ADR-0011).
 */
export function resolveBrandFromStorefrontConfig(config) {
  const base = {
    ...fallbackBrand,
    colors: { ...fallbackBrand.colors },
  };
  if (!config || typeof config !== "object") {
    return base;
  }

  const tenant = config.tenant || {};
  const branding = config.branding || {};
  const theme = config.theme || {};
  const colors = theme.colors || {};

  if (tenant.display_name) {
    base.name = tenant.display_name;
    base.shortName = tenant.display_name;
    base.title = tenant.display_name;
  }
  if (Object.prototype.hasOwnProperty.call(branding, "logo_url")) {
    base.logoSrc = branding.logo_url || "";
  }
  if (Object.prototype.hasOwnProperty.call(branding, "favicon_url")) {
    base.favicon = branding.favicon_url || "";
  }
  if (branding.support_email) {
    base.supportEmail = branding.support_email;
  }
  base.contacts = branding.contacts || {};

  if (colors.primary) base.colors.primary = colors.primary;
  if (colors.secondary) base.colors.primaryDark = colors.secondary;
  if (colors.accent) base.colors.accent = colors.accent;
  // primaryLight: derive lightly if API omits it
  if (colors.primary && !colors.primaryLight) {
    base.colors.primaryLight = colors.primary;
  }
  if (colors.primaryLight) base.colors.primaryLight = colors.primaryLight;

  base.tenant = {
    id: tenant.id ?? null,
    slug: tenant.slug ?? null,
    displayName: tenant.display_name ?? base.name,
    legalName: tenant.legal_name ?? "",
    legal_name: tenant.legal_name ?? "",
    edrpou: tenant.edrpou ?? "",
    legalAddress: tenant.legal_address ?? "",
    legal_address: tenant.legal_address ?? "",
  };
  base.features = {
    ...(config.features || {}),
    card_payment: Boolean(config.features?.card_payment),
    partner_sales: Boolean(config.features?.partner_sales),
  };
  base.navigation = config.navigation || { items: [] };
  base.homepage = config.homepage || {};
  base.listing = config.listing || {};
  base.legalPages = config.legal_pages || {};

  return base;
}
